import type { MiddlewareType } from '../types';

export function useMiddleware<State, Dispatch>(
  ...middleware: Array<MiddlewareType<State, Dispatch>>
) {
  return middleware.reduce((current, acc) => (args: [State, Dispatch]) => current(acc(args)));
}
